import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { benefitItems } from '@/mocks/home';

export default function BenefitsSection() {
  return (
    <section id="benefits" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="会员福利"
          title="会员可以享受的六项福利"
          desc="成为会员后，资源不只是「能看到」，而是「用得上」：从下载、打包到更新提醒与答疑，覆盖日常使用的每个环节。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {benefitItems.map((item, index) => (
            <Reveal key={item.title} delay={index * 60}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5">
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-900">
                    <i className={`${item.icon} text-xl`} aria-hidden="true" />
                  </span>
                  <h3 className="font-heading text-base font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                </div>
                <p className="mt-4 text-sm leading-relaxed text-foreground-700">{item.desc}</p>
                <p className="mt-3 border-t border-background-200 pt-3 text-xs leading-relaxed text-foreground-500">
                  {item.detail}
                </p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-8 flex flex-col items-start gap-4 rounded-lg border border-primary-200 bg-primary-50 p-5 sm:flex-row sm:items-center sm:justify-between md:p-6">
            <div className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-vip-crown-2-line text-lg" aria-hidden="true" />
              </span>
              <div>
                <p className="text-sm font-medium text-foreground-950">
                  会员福利每周同步补充
                </p>
                <p className="mt-0.5 text-xs leading-relaxed text-foreground-600">
                  想了解当前开放的福利内容，可以在下方社区数据与常见问题中查看更新说明。
                </p>
              </div>
            </div>
            <a
              href="#share"
              className="w-full whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto dark:text-foreground-950"
            >
              查看会员分享
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}